<template>
  <div>
    <item-select v-model="dd"
                 v-if="list !== null && list !== undefined"
                 :options="options"
                 :disabled="disabled"
                 :multiple="multiple" />

    <el-input v-else
              v-model="dd"
              :disabled="disabled"
              size="small"></el-input>
  </div>
</template>
<script>
import LibProductItem from '../../../minxin/ProductItem';

export default {
  name: "ProductItemTypeString",
  mixins: [LibProductItem],
  props: {
    value: {
      type: [String, Array],
      default: function () { return this.multiple ? [] : '' }
    },
  },
  computed: {
    options() { return this.list }
  },
}
</script>
